<template>
  <v-container
    class="pa-3"
    fluid
  >
    <v-layout wrap>
      <v-flex
        class="px-2"
        md3
        sm6
        xs12
      >
        <v-text-field
          :error-messages="errorMessages($v.myRun.config.coronal_model.SCS.start_radius)"
          @blur="$v.myRun.config.coronal_model.SCS.start_radius.$touch()"
          @input="$v.myRun.config.coronal_model.SCS.start_radius.$touch()"
          hint="Radius where SCS model starts"
          label="Inner radius"
          step="0.1"
          suffix="Rsun"
          type="number"
          v-model="myRun.config.coronal_model.SCS.start_radius"
        ></v-text-field>
      </v-flex>
      <v-flex
        class="px-2"
        md3
        sm6
        xs12
      >
        <v-text-field
          :error-messages="errorMessages($v.myRun.config.coronal_model.SCS.end_radius)"
          @blur="$v.myRun.config.coronal_model.SCS.end_radius.$touch()"
          @input="$v.myRun.config.coronal_model.SCS.end_radius.$touch()"
          disabled
          hint="Outer radius of SCS model"
          label="Outer radius"
          step="0.01"
          suffix="AU"
          type="number"
          v-model="myRun.config.coronal_model.SCS.end_radius"
        ></v-text-field>
      </v-flex>
      <v-flex
        class="px-2"
        md3
        sm6
        xs12
      >
        <v-text-field
          :error-messages="errorMessages($v.myRun.config.coronal_model.SCS.number_of_radial_grid_pts)"
          @blur="$v.myRun.config.coronal_model.SCS.number_of_radial_grid_pts.$touch()"
          @input="$v.myRun.config.coronal_model.SCS.number_of_radial_grid_pts.$touch()"
          hint="Number of radial grid points"
          label="Number of radial grid points"
          type="number"
          v-model="myRun.config.coronal_model.SCS.number_of_radial_grid_pts"
        ></v-text-field>
      </v-flex>
      <v-flex
        class="px-2"
        md3
        sm6
        xs12
      >
        <v-text-field
          :error-messages="errorMessages($v.myRun.config.coronal_model.SCS.max_degree)"
          @blur="$v.myRun.config.coronal_model.SCS.max_degree.$touch()"
          @input="$v.myRun.config.coronal_model.SCS.max_degree.$touch()"
          hint="Maximum degree of solid harmonic expansion"
          label="Maximum degree"
          type="number"
          v-model="myRun.config.coronal_model.SCS.max_degree"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import runMixin from '@/mixins/run';

export default {
  mixins: [runMixin],
};
</script>
